<app-button 
  [matMenuTriggerFor]="menu" 
  #menuTrigger
  icon="more"
  size="small"
></app-button>

<mat-menu #menu="matMenu" xPosition="before">
  <div class="popup_buttons_wrapper">
    <ng-content></ng-content>
  </div>
</mat-menu>